export default __webpack_public_path__ + "static/media/project-icon.6e4eb3fe.svg";